import { render, staticRenderFns } from "./OpenFormInCurrentWindow.vue?vue&type=template&id=16196d24&scoped=true"
import script from "./OpenFormInCurrentWindow.vue?vue&type=script&lang=js"
export * from "./OpenFormInCurrentWindow.vue?vue&type=script&lang=js"
import style0 from "./OpenFormInCurrentWindow.vue?vue&type=style&index=0&id=16196d24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16196d24",
  null
  
)

export default component.exports